import { render, staticRenderFns } from "./DesignPanel.vue?vue&type=template&id=44c4f976&"
import script from "./DesignPanel.vue?vue&type=script&lang=js&"
export * from "./DesignPanel.vue?vue&type=script&lang=js&"
import style0 from "./DesignPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports